import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import colors from 'common/styles/colors';
import { getCurrencyFromState } from 'common/utils/currencyUtils';
import {
  costSavedActivityFilters,
  seedActivityListFilters
} from 'home/Widget/helpers/helpers';
import { formatCompactCostSaved } from '../utils/orgWidgetFormatters';
import OrgShareBySiteWidget from './OrgShareBySiteWidget';

const WIDGET_NAME = 'org_cost_saved_by_site';

// Land on Activity filtered to the cost-saving tasks behind the number, the
// same place and filter the site-level total_cost_saved widget opens.
const costSavedSiteTarget = (accountId) => {
  seedActivityListFilters(accountId, costSavedActivityFilters());
  return '/activity';
};

const OrgCostSavedBySite = ({ currency, ...props }) => (
  <OrgShareBySiteWidget
    {...props}
    widgetName={WIDGET_NAME}
    siteLinkTo={costSavedSiteTarget}
    emptyMessageKey="orgView.costSaved.noData"
    emptyMessageDefault="No cost saved data"
    summaryLabelKey="orgView.costSaved.orgSummary"
    summaryLabelDefault="Total cost saved"
    getSummaryValue={summary => summary.cost_saved}
    getSiteValue={site => site.cost_saved}
    formatSummaryValue={value => formatCompactCostSaved(value, currency)}
    formatSiteValue={value => formatCompactCostSaved(value, currency)}
    renderSummaryMeta={(t, summary) => t('orgView.costSaved.meta', {
      count: summary.sites_with_savings != null ? summary.sites_with_savings : 0,
      defaultValue: '{{count}} sites with savings'
    })}
    barColor={colors.green}
  />
);

OrgCostSavedBySite.propTypes = {
  organisationId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  widgetsMetadata: PropTypes.object,
  title: PropTypes.string,
  currency: PropTypes.string
};

OrgCostSavedBySite.defaultProps = {
  widgetsMetadata: null,
  title: null,
  currency: 'USD'
};

const mapStateToProps = state => ({
  currency: getCurrencyFromState(state)
});

export default connect(mapStateToProps)(OrgCostSavedBySite);
